<template>
  <VueTypeaheadBootstrap
    v-model="search"
    @hit="handleSelect"
    :data="categorias"
    :serializer="getOptionText"
    :placeholder="placeholder"
    :class="[stateClass]"
    :showOnFocus="true"
    :size="size"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import { modelValue } from "@/mixins/modelValue";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {
      type: [String, Number, Object],
      default: null,
    },
    return_object: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Selecione uma categoria",
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin, modelValue("value", "change")],
  props,
  data: () => ({
    search: "",
    categorias: [],
  }),
  methods: {
    ...mapActions("tipos_instituicoes", {
      ActionCategoriasToSelect: "ActionCategoriasToSelect",
    }),
    getOptionValue(item) {
      if (!item) return null;
      return item.value !== undefined ? item.value : item.id;
    },
    getOptionText(item) {
      if (!item) return "";
      return item.text || item.nome || "";
    },
    setByValue(value) {
      if (!value && value !== 0) {
        this.search = "";
        return;
      }

      if (typeof value === "object") {
        this.search = this.getOptionText(value);
        return;
      }

      const selected = this.categorias.find(
        (categoria) => this.getOptionValue(categoria) == value
      );

      if (!selected) return;
      this.search = this.getOptionText(selected);
    },
    handleSelect($event) {
      if (this.return_object) {
        this.modelValue = $event;
        return;
      }

      this.modelValue = this.getOptionValue($event);
    },
  },
  watch: {
    search: function (value) {
      if (value !== "") return;
      this.modelValue = null;
    },
    modelValue: function (value) {
      this.setByValue(value);
    },
  },
  async created() {
    this.categorias = await this.ActionCategoriasToSelect();

    if (!this.value && this.value !== 0) return;
    this.setByValue(this.value);
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0;
  padding-left: 0;
  padding-top: 0;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
